var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcaseBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 8.00016H8.00671M10.6667 4.00016V2.66683C10.6667 2.31321 10.5262 1.97407 10.2762 1.72402C10.0261 1.47397 9.687 1.3335 9.33337 1.3335H6.66671C6.31309 1.3335 5.97395 1.47397 5.7239 1.72402C5.47385 1.97407 5.33337 2.31321 5.33337 2.66683V4.00016M14.6667 8.66683C12.6886 9.97282 10.3704 10.669 8.00004 10.669C5.62967 10.669 3.31151 9.97282 1.33337 8.66683M2.66671 4.00016H13.3334C14.0698 4.00016 14.6667 4.59712 14.6667 5.3335V12.0002C14.6667 12.7365 14.0698 13.3335 13.3334 13.3335H2.66671C1.93033 13.3335 1.33337 12.7365 1.33337 12.0002V5.3335C1.33337 4.59712 1.93033 4.00016 2.66671 4.00016Z",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseBusiness);
export default __webpack_public_path__ + "static/media/briefcase-business.5abf0067ca7d2bce2d7801d8533fd8ab.svg";
export { ForwardRef as ReactComponent };